var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.5002 16.8501H7.50018C5.84333 16.8501 4.50018 18.1932 4.50018 19.8501V30.3501C4.50018 32.007 5.84333 33.3501 7.50018 33.3501H28.5002C30.157 33.3501 31.5002 32.007 31.5002 30.3501V19.8501C31.5002 18.1932 30.157 16.8501 28.5002 16.8501Z",
    stroke: "#B3C3DA",
    strokeWidth: 3.00312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5002 16.8501V10.8501C10.5002 8.86097 11.2904 6.95332 12.6969 5.5468C14.1034 4.14027 16.0111 3.3501 18.0002 3.3501C19.9893 3.3501 21.897 4.14027 23.3035 5.5468C24.71 6.95332 25.5002 8.86097 25.5002 10.8501V16.8501",
    stroke: "#B3C3DA",
    strokeWidth: 3.00312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0b5182c581a2512302b3aa50c6463e3f.svg";
export { ForwardRef as ReactComponent };